export default {
  isLoggedIn (state) {
    return !!state.firebaseUser && !!state.firebaseIdToken
  },
  userEmail (state) {
    return state.firebaseUser && state.firebaseUser.email ? state.firebaseUser.email : null
  }
}
